module.exports = __webpack_public_path__ + "static/media/ic_alert.84324e82.svg";